module.exports = function () {
    if ($('.paragraph').length === 0) {
        return;
    }

    $('.paragraph__modaal-link').modaal({ custom_class: "paragraph__modaal-wrapper", type: "image" });
};